import { Model } from "./model";

export class BoxLocation extends Model {

  region: string;
  

}
